// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".show-cell {\n  background: white;\n  border-bottom: 1px solid lightgrey !important;\n  line-height: 6 !important;\n}\n", "",{"version":3,"sources":["webpack://src/pages/TAS/Nursery/ClassTable/style.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,6CAA6C;EAC7C,yBAAyB;AAC3B","sourcesContent":[".show-cell {\n  background: white;\n  border-bottom: 1px solid lightgrey !important;\n  line-height: 6 !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
